<template>
    <div class="content-item-container">
        <div class="content-item-text">
            <div class="content-item-num-c"><span class="content-item-num" :style="{color: color}">{{ item.num }}</span><span class="content-item-unit">{{ item.unit }}</span></div>
        </div>
        <div class="content-item-icon"><img :src="item.icon"></div>
        <div class="content-item-text" style="margin-top: -10px;">
            <div class="content-item-desc">{{ item.desc }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CTContentItem',
    props: [
        'item',
        'color'
    ]
}
</script>
<style scoped lang="less">
.content-item-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content-item-icon {
        flex: none;
        display: flex;
        align-items: center;
    }

    .content-item-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .content-item-num-c {
            height: 35px;
            display: flex;
            align-items: center;
            .content-item-num {
                color: #FFCA00;
                font-size: 14pt;
                font-weight: bold;
                font-style: italic;
            }

            .content-item-unit {
                color: #D8E2FF;
                font-size: 9pt;
                font-weight: thin;
                display: inline-block;
                margin-left: 5px;
                font-style: italic;
            }
        }

        .content-item-desc {
            height: 25px;
            color: #D8E2FF;
            font-size: 10pt;
            font-weight: light;
            flex: none;
            font-style: italic;
        }
    }
}
</style>